import { BaseWebComponentElement } from '../../framework/BaseWebComponentElement';
import { TargetsController } from '../controller/TargetsController';
import {
  ConsoleRequestSettings,
  NodesOptionsByServiceTargetId,
  SelectedTargets, SERVICE_TARGETS,
  TargetsDependencies,
  TargetsViewData,
} from '../type';
import { Observable } from 'rxjs';

export default class TargetsWebComponent extends BaseWebComponentElement {
  public controller!: TargetsController;
  private viewData: TargetsViewData;
  public apiType: string;
  private isSingleSelect = false;

  constructor() {
    super();

    this.initialSetup({
      controllerConstructor: TargetsController,
    });
  }

  injectDependencies(dependencies: TargetsDependencies) {
    super.injectDependencies(dependencies);
  }

  public setViewData(data: TargetsViewData): void {
    this.viewData = data;
  }

  public getViewData(): TargetsViewData {
    return this.viewData;
  }

  public updateSelectedTargetsWithCurrentFiltering(): void {
    this.controller.view.selectedTargets[this.controller.view.currentServiceTargetId] = [
      ...this.controller.view.dom.$targetsTree.selectedNodes,
    ];
  }

  public setSelectTargetsTitle(title: string): void {
    this.controller.view.dom.$selectTargetsTitle.innerText = title;
  }

  public setSelectedTargetsTitle(title: string): void {
    this.controller.view.dom.$selectedTargetsTitle.innerText = title;
  }

  public hideSelectTargetsTitle() {
    this.controller.view.hideSelectTargetsTitle();
  }

  public setInvalidTargetTypes(invalidTargets: number[]): void {
    this.controller.invalidTargetTypes = invalidTargets;
  }

  public setOptionsForGetChildrenNodes(options: NodesOptionsByServiceTargetId): void {
    this.controller.optionsForGetChildrenNodes = options;
  }

  public setDataProviderConsoleRequestSettings(options: ConsoleRequestSettings): void {
    this.controller.consoleRequestSettings = options;
  }

  public getSelectedTargets(): SelectedTargets {
    this.updateSelectedTargetsWithCurrentFiltering();
    return this.controller.convertProtectedEntityToServiceTargets();
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.formGroup.valid$;
  }

  public get valid(): boolean {
    if (!this.controller.view.formGroup) {
      return false;
    }
    return this.controller.view.formGroup.valid;
  }

  public removeValidators(): void {
    this.controller.view.removeValidators();
  }

  public setRequiredValidators(): void {
    this.controller.view.setRequiredValidators();
  }

  public getShowOnlyCompaniesFlag(): boolean {
    return this.controller.showOnlyCompanies;
  }

  public getCurrentCompanyId(): string {
    return this.controller.view.companyId;
  }

  public setIsSingleSelect(isSingleSelect: boolean): void {
    this.isSingleSelect = isSingleSelect;
  }

  public getIsSingleSelect(): boolean {
    return this.isSingleSelect;
  }

  public get hasUnsavedChanges(): boolean {
    let finalState = false;

    for (const key of Object.keys(SERVICE_TARGETS)) {
      if (
        !this.controller.view.initialSelectedTargets[SERVICE_TARGETS[key].id] &&
        !this.controller.view.currentSelectedTargets[SERVICE_TARGETS[key].id]
      ) {
        continue;
      }

      if (
        !this.controller.view.initialSelectedTargets[SERVICE_TARGETS[key].id] &&
        this.controller.view.currentSelectedTargets[SERVICE_TARGETS[key].id]
      ) {
        finalState = true;
        break;
      }

      if (
        this.controller.view.initialSelectedTargets[SERVICE_TARGETS[key].id].length !==
        this.controller.view.currentSelectedTargets[SERVICE_TARGETS[key].id].length
      ) {
        finalState = true;
        break;
      }

      const state = this.controller.view.initialSelectedTargets[SERVICE_TARGETS[key].id].every(
        (val, index) => val === this.controller.view.currentSelectedTargets[SERVICE_TARGETS[key].id][index]
      );
      if (!state) {
        finalState = true;
        break;
      }
    }

    return finalState;
  }
}
